import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "variant", "size", "beforeIcon", "afterIcon", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.button-link */
import { useThemeUI } from 'theme-ui';
import { path } from '@uswitch/ev-utils/obj';
import { DynamicSparkIcon } from '../spark-icons/dynamic-spark-icon';
import { Link } from '@uswitch/ev-core/react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export var ButtonLink = function ButtonLink(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'large' : _ref$size,
      beforeIcon = _ref.beforeIcon,
      afterIcon = _ref.afterIcon,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var displayIcon = function displayIcon(type, icon) {
    return _jsx("div", {
      sx: {
        display: 'inline',
        variant: "elements.buttons.variants.".concat(variant, ".").concat(type)
      },
      children: _jsx(DynamicSparkIcon, {
        glyph: icon,
        color: path("elements.buttons.variants.".concat(variant, ".color").split('.'), theme, 'base'),
        direction: "right",
        size: 22
      })
    });
  };

  return _jsxs(Link, _objectSpread(_objectSpread({
    sx: {
      cursor: 'pointer',
      backgroundImage: 'none',
      fontFamily: 'base',
      fontSize: path("elements.buttons.base.btnSize.".concat(size, ".fontSize").split('.'), theme, 'base'),
      paddingX: path("elements.buttons.base.btnSize.".concat(size, ".paddingX").split('.'), theme, 'sm'),
      paddingY: path("elements.buttons.base.btnSize.".concat(size, ".paddingY").split('.'), theme, 'base'),
      height: path("elements.buttons.base.btnSize.".concat(size, ".height").split('.'), theme, 'base'),
      width: size === 'fullWidth' ? path("elements.buttons.base.btnSize.".concat(size, ".width").split('.'), theme, 'base') : 'unset',
      display: 'inline-block',
      textDecoration: 'none',
      variant: "elements.buttons.variants.".concat(variant)
    },
    onClick: onClick
  }, props), {}, {
    children: [beforeIcon ? displayIcon('beforeIcon', beforeIcon) : null, _jsx("div", {
      sx: {
        display: 'inline',
        backgroundColor: 'inherit',
        variant: "elements.buttons.variants.".concat(variant, ".content")
      },
      children: children
    }), afterIcon ? displayIcon('afterIcon', afterIcon) : null]
  }));
};
//# sourceMappingURL=index.js.map